import React from "react";
import BaseMenuPrincipal from "../../../componentes/BaseMenuPrincipalComponent/BaseMenuPrincipal";
import InfoLateralResumoGeralComponent from "../../../componentes/InfoLateralResumoGeralComponent/InfoLateralResumoGeralComponent";

const ResumoGeral = () => {
    return(
        <main>
            <BaseMenuPrincipal 
                InfoLateral = {<InfoLateralResumoGeralComponent />}/>

        </main>
    )
}

export default ResumoGeral;